export default __webpack_public_path__ + "static/media/gallery_00.c25af22f.jpg";